import type { PaymentMethodResponse } from '@kimuno/api-sdk';
import { spaces } from '@kimuno/theme';
import { Box } from '@mui/material';
import type React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { UserPaymentMethodType } from '../../types/User';
import { paymentMethodMap } from '../../utils/paymentMethodMapUserPaymentMethod';
import useScreenSize from '../../utils/useScreenSize';
import SettingItem from '../SettingItem';
import PaymentMethods from './PaymentMethods';

interface PaymentInfoRendererProps {
	isEditMode: boolean;
	currentPaymentMethod: PaymentMethodResponse;
	children: React.ReactNode;
}

const PaymentInfoRenderer = ({
	isEditMode,
	currentPaymentMethod,
	children,
}: PaymentInfoRendererProps) => {
	const { isXsScreen, isSmScreen } = useScreenSize();
	const { t } = useTranslation();

	const [selectedMethod, setSelectedMethod] = useState<string>(currentPaymentMethod.type);

	// If the current payment method is invoice, only at that case invoice will available
	const availablePaymentMethods: UserPaymentMethodType[] = [
		...(currentPaymentMethod.type === UserPaymentMethodType.INVOICE
			? [UserPaymentMethodType.INVOICE]
			: []),
		UserPaymentMethodType.SEPA,
		UserPaymentMethodType.PAYPAL,
		UserPaymentMethodType.CREDIT_CARD,
	];

	const onChangeMethod = (method: UserPaymentMethodType) => setSelectedMethod(method);

	return (
		<Box
			sx={{
				display: 'grid',
				gridTemplateColumns: isXsScreen || isSmScreen ? '1fr' : '1fr 1fr',
				gap: spaces.md,
			}}
		>
			<SettingItem title={t('Payment method')} sx={{ display: 'inline-flex' }}>
				<PaymentMethods
					isEditMode={isEditMode}
					availablePaymentMethods={availablePaymentMethods}
					selectedMethodType={selectedMethod}
					currentMethodIcon={paymentMethodMap(currentPaymentMethod).icon}
					currentMethodText={paymentMethodMap(currentPaymentMethod).text}
					onChangeMethod={onChangeMethod}
				/>
			</SettingItem>
			<SettingItem title={t('Payment rhythm')}>{children}</SettingItem>
		</Box>
	);
};

export default PaymentInfoRenderer;
